// Drive types (mutually exclusive radio buttons)
export const DRIVE_TYPES = [
  { value: 'standard', label: 'Standard' },
  { value: 'hybrid', label: 'Hybrid' },
  { value: 'electric', label: 'Electric' }
];

// Generate years from 2005 to current + 1
const currentYear = new Date().getFullYear();
export const VEHICLE_YEARS = Array.from(
  { length: currentYear - 2005 + 2 },
  (_, i) => currentYear + 1 - i
);
